export interface StorydocTheme {
  id: string;
  title: string;
  primaryColor: string;
  secondaryColor: string;
  themeColor3: string;
  themeColor4: string;
  backgroundColor: string;
  backgroundColor2: string;
}

export const storydocThemes: StorydocTheme[] = [
  {
    title: "Ocean Blue",
    primaryColor: "#1571E7",
    themeColor4: "#1571E7",
    themeColor3: "#163047",
    secondaryColor: "#EEF0F2",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "F0jLkeAIBUd1C6p",
  },
  {
    title: "Aqua Teal",
    primaryColor: "#02B2D7",
    themeColor4: "#02B2D7",
    themeColor3: "#003642",
    secondaryColor: "#CAF1F8",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "KFTTJDPgeQhaNEn",
  },
  {
    title: "Warm Gray",
    primaryColor: "#9A8F97",
    themeColor4: "#9A8F97",
    themeColor3: "#2D2B2C",
    secondaryColor: "#E9E3E5",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "eUj5ejqDkvRaSLv",
  },
  {
    title: "Fresh Green",
    primaryColor: "#1BBC70",
    themeColor4: "#1BBC70",
    themeColor3: "#0A4B2D",
    secondaryColor: "#D7F3DC",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "QKHrlvuBiYdNrd1",
  },
  {
    title: "Royal Purple",
    primaryColor: "#7113C9",
    themeColor4: "#7113C9",
    themeColor3: "#0D0C17",
    secondaryColor: "#E7D8F7",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "ITPgDWvIpd5zqww",
  },
  {
    title: "Sand Beige",
    primaryColor: "#CCC8AB",
    themeColor4: "#CCC8AB",
    themeColor3: "#232021",
    secondaryColor: "#F2EEED",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "MN4j6bBB4YaD9wE",
  },
  {
    title: "Earthy Sage",
    primaryColor: "#B2A59B",
    themeColor4: "#B2A59B",
    themeColor3: "#505F60",
    secondaryColor: "#FAEED1",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "ZfILJ74SbNIA6cf",
  },
  {
    title: "Vivid Orange",
    primaryColor: "#FF6002",
    themeColor4: "#FF6002",
    themeColor3: "#454545",
    secondaryColor: "#FDE6C6",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "51va3d9tebAG0s6",
  },
  {
    title: "Soft Lavender",
    primaryColor: "#A183C9",
    themeColor4: "#A183C9",
    themeColor3: "#534C8D",
    secondaryColor: "#F0DFEF",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "7MDHfm580eZFLvX",
  },
  {
    title: "Bold Yellow",
    primaryColor: "#FCD507",
    themeColor4: "#FCD507",
    themeColor3: "#000000",
    secondaryColor: "#DEDEDE",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "xAzKl50UN3KVYEL",
  },
  {
    title: "Amber Gold",
    primaryColor: "#FCA311",
    themeColor4: "#FCA311",
    themeColor3: "#1C1C1C",
    secondaryColor: "#EAE2CD",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "pKZxnqRHrOCZ5QX",
  },
  {
    title: "Coral Pink",
    primaryColor: "#E83D5F",
    themeColor4: "#E83D5F",
    themeColor3: "#29304A",
    secondaryColor: "#F5F5F5",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "ulikHNK8TfSYdbB",
  },
  {
    title: "Warm Rose",
    primaryColor: "#F23861",
    themeColor4: "#F23861",
    themeColor3: "#45171A",
    secondaryColor: "#F9DDC6",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "UeaFu6Bz6s0r9fe",
  },
  {
    title: "Cherry Red",
    primaryColor: "#EF2E3F",
    themeColor4: "#EF2E3F",
    themeColor3: "#5F1218",
    secondaryColor: "#F5ECED",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "I8mZFGNkd8vSdee",
  },
  {
    title: "Deep Indigo",
    primaryColor: "#6953EC",
    themeColor4: "#6953EC",
    themeColor3: "#1D1548",
    secondaryColor: "#E0DEEB",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "T4vcdutuWj7wkWA",
  },
  {
    title: "Neon Lime",
    primaryColor: "#A9EE00",
    themeColor4: "#A9EE00",
    themeColor3: "#212323",
    secondaryColor: "#EFF2EB",
    backgroundColor: "#FFFFFF",
    backgroundColor2: "#F8F8F8",
    id: "Uq8ffu773rJmESp",
  },
];
